import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Form, InputGroup } from 'react-bootstrap';
import ContentCard from '../components/ContentCard';
import Main from '../components/Main';
import Carousel from 'react-bootstrap/Carousel';
import { useLanguage } from "../LanguageContext";

import '../assets/styles/Home.css';
import { useState } from 'react';


const images = {};

function importAll(r) {
  r.keys().forEach((key) => {
    images[key.replace('./', '')] = r(key);
  });
}


// Imports all icons from the home_icons folder into the images array

importAll(require.context('../assets/images/home_icons', false, /\.(png|jpe?g|svg)$/));

const contentItems = [
  {
    icon: images['equity.png'],
    title: 'IQOSYS equity',
    description:
    <>
      All IQOSYS members participate in the value created individually and collectively through earned
      <span style={{color: "#B600FF", fontWeight: "bold"}}> IQOSYS equity</span>
      , giving them a voice in corporate governance, a stake in the group’s financial performance, and ensuring alignment around our raison d’être – consistently delivering outstanding customer service.'
    </>
  },
  {
    icon: images['meritocracy.png'],
    title: 'Meritocracy',
    description:
    <>
      We run a walk the talk
      <span style={{color: "#B600FF", fontWeight: "bold"}}> meritocraty</span>.
      All of our members operate in a system where the rules of the game are transparent and identical for all. Each contributor’s earnings are 100% commensurate with the value delivered to our customers.'
    </>
  },
  {
    icon: images['vetting_process.png'],
    title: 'Selective vetting',
    description:
    <>
      We operate a<span style={{color: "#B600FF", fontWeight: "bold"}}> selective vetting process </span>
      to ensure that our IQosystem is composed of a mix of customer-obsessed full-time staff members, highly qualified engineers and a network of hand-picked entrepreneurs, contributing on an ad hoc basis.'
    </>
  },
  {
    icon: images['score.png'],
    title: 'Clients score',
    description:
    <>
      <span style={{color: "#B600FF", fontWeight: "bold"}}>Clients score our work </span>
      regularly using KPIs that they themselves define; whether technical expertise, managerial acumen, soft skills, or the quality of our recommendations. These scores enable us to mobilize the best teams for your specific needs.'
    </>
  },
  {
    icon: images['success_fee.png'],
    title: 'Success fee',
    description:
    <>
    All of our projects contain a
    <span style={{color: "#B600FF", fontWeight: "bold"}}> success fee </span>
    that’s paid out upon achieving the specific objectives agreed upon between project managers and consultant at the outset of a project, giving clients full control over goal alignment and delivery.
    </>
  },
];

const proxyUrl = process.env.REACT_APP_PROXY;

const Home = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const handlePageClick = (path) => {
    navigate(path); // Redirect to the page that has the path of the argument
  };

  return (
    <Main componentList={[
        <Row>
        <p style={{ color: "#4472c4", fontSize: "1.5rem", fontWeight: "bold" }}>
        <br/>
        IQOSYS offers premium professional services on demand.
        Our innovative business model has been designed with one
        main objective: to systematically <span style={{ color: "#B600FF" }}>
        measurable business results </span>
        that <span style={{ color: "#B600FF" }}>
        exceed customer expectations</span>.
        <br />
        <br />
        Here’s how we do it:
        </p>


        {/* Carousel for the ContentCards */}

        <Carousel style={{ maxWidth: '100%', height: '200px', margin: '0 auto' }}>
          {contentItems.map((item, index) => (
            <Carousel.Item key={index}>
                <ContentCard
                  icon={item.icon}
                  title={item.title}
                  description={item.description}
                />
            </Carousel.Item>
          ))}
        </Carousel>
        <hr/>
        <Row className="d-flex justify-content-start pb-3">
          <Col md={7} className="d-flex flex-column justify-content-start">
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('/myaccount/signin')}
            >
              My account
            </span>
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('/aboutus/services')}
            >
              About us
            </span>
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('/myaccount/signin')}
            >
              My account
            </span>
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('/ourleaders/sector')}
            >
              Exec Partners
            </span>
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('/ourleaders/practice')}
            >
              Practices
            </span>
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('/projects')}
            >
              Projects
            </span>
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('/aboutus/iqstokens')}
            >
              IQS Tokens
            </span>
            <span
              style={{ fontWeight: 'bold', cursor: 'pointer' }}
              onClick={() => handlePageClick('')}
            >
              Terms of use
            </span>
          </Col>
          <Col md={5} className="d-flex flex-column justify-content-center">
            <span
              style={{ fontWeight: 'bold' }}
            >
              Let's connect
            </span>
            <span>
              Subscribe to our newsletter and get prime access to our white papers, best practices and thought leadership 
            </span>

            <Form className="p-0 mt-1 mb-1">
              <Form.Group controlId="formEmail" style={{ marginBottom: "3px" }}>
                <InputGroup>
                  <Form.Control
                    type="email"
                    placeholder="Your e-mail address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{border : "1px solid #bfbfbf", borderRadius : "0"}}
                  />
                </InputGroup>
              </Form.Group>
            </Form>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div 
                style={{
                  backgroundColor: '#0000FF',
                  borderRadius: '10%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '30px', 
                  height: '30px'
                }}
              >
                <img style={{width : "60%"}} src={images['mail.png']} alt="sign-in" />
              </div>
              <span className="button-text">Submit e-mail</span>
            </div>

          </Col>
        </Row>

        <h7 style={{textAlign:"center"}}>
        © Copyright 2024 IQOSYS SAS.
          
          <br/>
          <a href={proxyUrl + "terms_and_RGPD/RGPD_" + language + ".pdf"}>Data Protection and Privacy Policy</a> | <span></span>
          <a href={proxyUrl + "terms_and_RGPD/Terms_" + language + ".pdf"}>General Terms and Conditions of Use</a>
        </h7>
        </Row>
    ]} />
  );
}

export default Home;
